<template>
  <div class="input-group mb-3">
    <input id="input-password-value" :type="toggle ? 'text' : 'password'" class="form-control" style="border-right: none;">
    <div class="input-group-append" @click="toggle = !toggle">
      <span class="input-group-text custom-append"><i :class="{ 'far fa-eye': toggle == false, 'fas fa-eye-slash': toggle == true}"></i></span>
      <!-- <button @click="toggle = !toggle" class="btn" type="button" id="button-addon2"><i :class="{ 'far fa-eye': toggle == false, 'fas fa-eye-slash': toggle == true}"></i></button> -->
    </div>
  </div>
</template>
<script>
export default {
  name: "",
  data: () => ({
    toggle: false,
  })
}
</script>
<style>
  .custom-append {
    background-color: #fff !important;
    border-left: none;
  }
</style>
